import React, { useState, useMemo } from 'react';
import { CATEGORIES, WORKERS, getCategoryCount } from '../mock';
import WorkerCard from './WorkerCard';

const RosterSection = () => {
  const [active, setActive] = useState('all');

  const filtered = useMemo(() => {
    if (active === 'all') return WORKERS;
    return WORKERS.filter((w) => w.category.includes(active));
  }, [active]);

  return (
    <section id="roster" className="mx-auto max-w-7xl px-6 py-14">
      {/* Category filter */}
      <div className="mb-8 flex flex-wrap items-center justify-center gap-2">
        {CATEGORIES.map((cat) => {
          const count = getCategoryCount(cat.key);
          const isActive = active === cat.key;
          return (
            <button
              key={cat.key}
              onClick={() => setActive(cat.key)}
              className={
                'inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm transition-all duration-150 ' +
                (isActive
                  ? 'border-neutral-900 bg-neutral-900 text-white'
                  : 'border-neutral-200 bg-white text-neutral-700 hover:border-neutral-300 hover:bg-neutral-50')
              }
            >
              <span>{cat.label}</span>
              <span
                className={
                  'rounded-full px-1.5 text-[11px] font-medium ' +
                  (isActive ? 'bg-white/20 text-white' : 'bg-neutral-100 text-neutral-500')
                }
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Grid */}
      <div className="grid auto-rows-fr grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {filtered.map((w) => (
          <WorkerCard key={w.id} worker={w} />
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="py-24 text-center text-neutral-500">
          No workers in this category yet.
        </div>
      )}
    </section>
  );
};

export default RosterSection;
